// Polling-based chat service for shared hosting fallback
class PollingChatService {
  constructor() {
    this.leadId = null;
    this.lastMessageId = 0;
    this.pollingInterval = null;
    this.isPolling = false;
    this.messageCallbacks = [];
    this.typingCallbacks = [];
  }

  // Start polling for messages
  startPolling(leadId) {
    this.leadId = leadId;
    this.isPolling = true;
    
    // Poll every 2 seconds
    this.pollingInterval = setInterval(() => {
      this.checkForNewMessages();
    }, 2000);
    
    console.log(`Started polling for lead ${leadId}`);
  }

  // Stop polling
  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    this.isPolling = false;
    console.log('Stopped polling');
  }

  // Check for new messages
  async checkForNewMessages() {
    if (!this.leadId || !this.isPolling) return;

    try {
      const response = await fetch(`/api/lead-messages/${this.leadId}?since=${this.lastMessageId}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
        // Update last message ID
        this.lastMessageId = data.data[data.data.length - 1].id;
        
        // Notify callbacks
        this.messageCallbacks.forEach(callback => {
          callback(data.data);
        });
      }
    } catch (error) {
      console.error('Polling error:', error);
    }
  }

  // Send a message
  async sendMessage(message, leadId) {
    try {
      const response = await fetch('/api/lead-messages', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          lead_id: leadId,
          message: message
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Send message error:', error);
      throw error;
    }
  }

  // Subscribe to new messages
  onNewMessage(callback) {
    this.messageCallbacks.push(callback);
  }

  // Subscribe to typing indicators
  onTyping(callback) {
    this.typingCallbacks.push(callback);
  }

  // Send typing indicator
  async sendTyping(leadId, isTyping) {
    try {
      await fetch('/api/chat/typing', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          lead_id: leadId,
          is_typing: isTyping
        })
      });
    } catch (error) {
      console.error('Typing indicator error:', error);
    }
  }

  // Get connection state
  getConnectionState() {
    return this.isPolling ? 'connected' : 'disconnected';
  }
}

// Create singleton instance
const pollingChatService = new PollingChatService();

export default pollingChatService;
